// 邮箱正则
export function isEmail(s){
  return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}
//手机号正则
export function isPhone(s){
  return /^1[3|4|5|7|8][0-9]{9}$/.test(s)
}
//去空格正则
export function isPwd(s){
  return /^\S+$/.test(s)
}



//////////////////
// WEBPACK FOOTER
// ./static/validate.js
// module id = null
// module chunks = 